import { concat, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';

export function debounceAllButFirst<T>(time: number): MonoTypeOperatorFunction<T> {
  return (source: Observable<T>) => concat(
    source.pipe(take(1)),
    source.pipe(debounceTime(time))
  );
}
